var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgTable = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M16.75 3.25v3.5H3.25v-3.5zM3.25 8H7v3.75H3.25zm5 3.75V8h3.5v3.75zm3.5 1.25h-3.5v3.75h3.5zM13 16.75V13h3.75v3.75zm0-5V8h3.75v3.75zM3.25 13H7v3.75H3.25zM18 2H2v16h16z",
  clipRule: "evenodd"
})));
export default SvgTable;